
// import Main from './pages/Main';
import CssBaseline from '@material-ui/core/CssBaseline';
import { BrowserRouter as Router, Route, Switch } from 'react-router-dom';
import VideoTutorial from './video-tutorial/VideoTutorial';
import ChangeLog from './change-log/ChangeLog';
import Download from './download/Download';
import CookiesPolicy from './Component/CookiesPolicy';
import PrivacyPolicy from './Component/PrivacyPolicy';
import ContactUs from './Component/ContactUs';
import Release from './release/Release';
import { createTheme } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/styles';
import { teal, indigo } from '@material-ui/core/colors';

const theme = createTheme({
  palette: {
    primary: teal,
    secondary: indigo,
  },
});

const AMO = () => <h1 style={{color:"white"}}>AMO</h1>
function App() {
  return (
    <ThemeProvider theme={theme}>
    
      <CssBaseline />
      <Router>
          <Switch>
              <Route exact path="/" component={Download} />
              <Route path="/dl-nara" component={Download} />
              <Route path="/video-tutorial" component={VideoTutorial} />
              <Route path="/change-log" component={ChangeLog} />
              <Route path="/amo" component={AMO} />
              <Route path="/cookies-policy" component={CookiesPolicy} />
              <Route path="/privacy-policy" component={PrivacyPolicy} />
              <Route path="/contact-us" component={ContactUs} />
              <Route path="/release/:version" component={Release} />
          </Switch>
      </Router>
    </ThemeProvider>
  )
}

export default App;
